import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { empModulo } from '../../../diccionarios/empModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { ReportesService } from '../../../services/administrador/reportes.service';
import { CrearEmpleadoService } from '../../../services/administrador/crear-empleado.service';
import { EmpresasModel } from '../../../models/empresasModel';

@Component({
  selector: 'app-rechazados-documentacion',
  templateUrl: './rechazados-documentacion.component.html',
  styleUrls: ['./rechazados-documentacion.component.css']
})
export class RechazadosDocumentacionComponent implements OnInit {

  EmpleadoModal: any = { nombres: '' , cedula : '' };
  private tooltipShowDelay;

  empModulo: any = {};
  formulario: FormGroup;//formulario
  
  loading: boolean = false;
  listaVacia: boolean = true;
  mostrarCard: boolean = true;
  resposiveFull: string;

  columnDefs: any[];//aggrid
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  textoBuscar: string;
  
  dataEdit: any = {};
  arrayEdit: any[] = [];

  cmbEmpresas:EmpresasModel[] = [];
  formularioEmp: FormGroup;
  // cmbLocalidad: any;
  cmbDepartamentoSolicita: any[] = [];
  cmbEmpleadoSolicita: any[];
  cmbEmpresaSolicita: EmpresasModel[] = [];
  // OK(Activo) y NO(Inactivo)
  SI_ACTIVO = 'Activo';
  NO_INACTIVO = 'Inactivo';

  constructor(private fb: FormBuilder, private _util: UtilsService, private _reporteService: ReportesService,  private _crearEmpleado: CrearEmpleadoService) { }

  ngOnInit() {
    this.empModulo = empModulo;
    this.resposiveFull = this.empModulo.div.resposiveFull;
    this.formulario = this.fb.group({
      codigoEmpresa: ['', [Validators.required]],
    });
    this.formularioEmp = this.fb.group({
      codEmpleado: ['', [Validators.required]],
      accesoIESS: ['', [Validators.required]],
      observacion: ['', [Validators.required]],
      fechaCambio: ['', [Validators.required]]
    });
    this.cargarGrid();
    this.getData();
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Cédula',
        field: 'cedula',
        filter: true,
        width: 180,
        tooltipField: 'cedula',
        tooltipComponentParams: { color: '#ececec' },
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha de Cambio',
        field: 'fechaCambio',
        sortable: true,
        width: 180,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nombres',
        field: 'nombres',
        sortable: true,
        filter: true,
        width: 250,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Descripción empresa',
        field: 'empresa.descripcion',
        sortable: true,
        width: 280,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'País Nacimiento',
        field: 'paisNacimiento',
        sortable: true,
        width: 170,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha último contrato',
        field: 'fechaUltimoContrato',
        sortable: true,
        width: 170,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Ingreso',
        field: 'fechaIngreso',
        sortable: true,
        width: 170,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Salida',
        field: 'fechaSalida',
        sortable: true,
        width: 170,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.guardarSI.bind(this),
          label: 'SI',//this.DAT_BTNS.eliminar,//buttons.eliminar,
          colorBoton: 'btn btn-success'//'btn btn-danger btn btn-block'
        }
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  getData() {
    //getAllEmpleadoEmpresa
    this.loading = true;
    this._crearEmpleado.getAllRechazados().subscribe((res: any[]) => {
      this.rowData = res;
      this.loading = false;
      this.listaVacia = (res.length === 0 ) ? true : false;
    }, (err) => {
      this.rowData = [];
      this.loading = false;
      this.listaVacia = true;
      this._util.mensajeErroToast(err.error.message, 2000);
      console.log(err);
    });
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  guardarSI({ rowData }) {
    this.formularioEmp.get('codEmpleado').setValue((rowData.codEmpleado === undefined)? '' : (rowData.codEmpleado === '')? '': rowData.codEmpleado);
    this.formularioEmp.get('fechaCambio').setValue(rowData.fechaCambio);
    this.formularioEmp.get('accesoIESS').setValue(this.SI_ACTIVO);
    this.formularioEmp.get('observacion').setValue(this.SI_ACTIVO);
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar el siguiente registro ?',
        text: '',
        action: 'Guardar',
        funcion: this._crearEmpleado.saveDocumentos(this.formularioEmp.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formularioEmp.reset();
      document.getElementById('cerrarModal').click();
      this.getData();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });
  }


}
